import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const Root = superstyled({
  styles: ({ theme }) => ({
    position: 'fixed',
    top: 0,
    width: '100%',
    height: 28,
    zIndex: `${theme.zIndex.appBar + 1}`,
    backgroundColor: theme.palette.background.red.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 1rem',
  }),
});

export const Label = superstyled({
  tag: Text,
  propsAdded: {
    truncate: true,
  },
});
